import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuth } from "../config/axiosInstance";
import { PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL } from "../config/api_config";

const enrolledCourses = (courses = []) => courses.filter((course) => Boolean(course?.course_id));

const sortCourses = (courses) => [...courses].sort((firstCourse, secondCourse) => {
    const firstIsCompleted = firstCourse.course_progress === 100;
    const secondIsCompleted = secondCourse.course_progress === 100;

    if (firstIsCompleted !== secondIsCompleted) {
        return firstIsCompleted ? 1 : -1;
    }

    return secondCourse.course_progress - firstCourse.course_progress;
});

export const fetchCourseList = createAsyncThunk(
    'courseList/fetchCourseList',
    async () => {
        const response = await axiosAuth.get(
            `${PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL}/api/v1/courses`
        );
        const courses = sortCourses(enrolledCourses(response.data ?? []).map((course) => ({
            course_id: course.course_id,
            course_name: course.course_title,
            course_title: course.course_title,
            course_progress: Number(course.course_progress) || 0,
        })));
        return {
            courses,
            subject_names: courses.map((course) => course.course_name),
        };
    }
);

const initialState = {
    courseName: "",
    courseId: null,
    courses: [],
    subject_names: [],
};

const courseListSlice = createSlice({
    name: 'courseList',
    initialState,
    reducers: {
        updateCourseName: (state, action) => {
            const selection = action.payload;
            const courseName = typeof selection === 'string' ? selection : selection?.course_name;
            const courseId = typeof selection === 'string' ? null : selection?.course_id;
            const matchingCourse = state.courses.find(
                (course) => course.course_id && course.course_name?.toLowerCase() === courseName?.toLowerCase()
            );

            state.courseName = courseName || "";
            state.courseId = courseId || matchingCourse?.course_id || null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchCourseList.fulfilled, (state, action) => {
            state.courses = action.payload.courses;
            state.subject_names = action.payload.subject_names;

            if (state.courseName) {
                const matchingCourse = action.payload.courses.find(
                    (course) => course.course_id && course.course_name?.toLowerCase() === state.courseName.toLowerCase()
                );
                state.courseId = matchingCourse?.course_id || null;
            }
        });
    },
});

export const { updateCourseName } = courseListSlice.actions;
export const selectCourseList = (state) => state.courseList;
export const selectCurrentCourseId = (state) => state.courseList?.courseId;
export const selectEnrolledCourses = (state) => enrolledCourses(state.courseList?.courses);
export default courseListSlice.reducer;
